module.exports = __webpack_public_path__ + "static/media/zea_mays.whole_plant.9c89f587.svg";